import { memo, useState } from 'react';
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons/faChevronDown';
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons/faChevronRight';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';

import { Text, TextType } from 'ui-components/components/text';

import styles from './tree-node.module.less';

type SchemaNode = {
  label?: string;
  property?: string;
  schema?: Record<string, unknown>;
};

type TreeNodeProps = {
  label?: string;
  property?: string;
  schema?: Record<string, unknown>;
  level: number;
  onSelect: (path: string) => void;
};

const Node = ({ label, property, schema, onSelect, level }: TreeNodeProps) => {
  const [isExpanded, setIsExpanded] = useState(true);

  const hasSchema = schema !== undefined;
  const isLeaf = property !== undefined;
  const isRoot = level === 0;

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };

  const handleLeafClick = () => {
    if (property !== undefined) {
      onSelect(property);
    }
  };

  const renderChildren = () => {
    if (!hasSchema || !isExpanded) {
      return null;
    }

    const schemaRecord = schema as Record<string, unknown>;
    return (
      <div className={classNames({ [styles.children]: !isRoot })}>
        {Object.keys(schemaRecord).map((key) => {
          const nestedSchema = schemaRecord[key] as SchemaNode;
          return (
            <TreeNode
              key={key}
              label={nestedSchema.label}
              level={level + 1}
              onSelect={onSelect}
              property={nestedSchema.property}
              schema={nestedSchema.schema}
            />
          );
        })}
      </div>
    );
  };
  return (
    <>
      {!isRoot ? (
        <button
          className={classNames(styles['node-content'], { [styles.leaf]: isLeaf, [styles.branch]: !isLeaf })}
          onClick={isLeaf ? handleLeafClick : handleToggle}
        >
          {!isLeaf && <FontAwesomeIcon className={styles.icon} icon={isExpanded ? faChevronDown : faChevronRight} />}
          <Text element='span' textType={TextType.Paragraph} value={label ?? ''} />
        </button>
      ) : null}
      {renderChildren()}
    </>
  );
};

export const TreeNode = memo(Node);
